import { render } from "./CookDeliveryComponent.vue?vue&type=template&id=ade21296&scoped=true"
import script from "./CookDeliveryComponent.vue?vue&type=script&lang=js"
export * from "./CookDeliveryComponent.vue?vue&type=script&lang=js"

import "./CookDeliveryComponent.vue?vue&type=style&index=0&id=ade21296&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade21296"]])

export default __exports__